let showErrorHandler = null;

export const registerAuthHandlers = ({ showError }) => {
  showErrorHandler = showError;
};

export const triggerGlobalError = () => {
  if (typeof showErrorHandler === 'function') {
    showErrorHandler();
  } else {
    console.warn('[authBridge] showError handler is not registered yet');
  }
};
